<template>
    <v-card id="release-of-information-data">
        <v-card-title>
            Submissions
            <v-spacer></v-spacer>
            <v-text-field v-model="filterTerm" prepend-inner-icon="mdi-filter" clearable hide-details
                label="Filter Term (Optional)" single-line>
            </v-text-field>
        </v-card-title>
        <v-card-text>
            <v-data-table :headers="headers" :items="data" :search="filterTerm" sort-by="user.cn">
                <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn :color="primaryColor" dark icon v-bind="attrs" v-on="on"
                                @click.stop="openDialog(item)">
                                <v-icon>mdi-information</v-icon>
                            </v-btn>
                        </template>
                        <span>View</span>
                    </v-tooltip>
                </template>
                <template v-slot:item.lastUpdatedDate="{ item }">
                    {{ getLastUpdatedDate(item) }}
                </template>
            </v-data-table>
            <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-toolbar dark :color="toolbarColor">
                    <v-btn icon dark @click="closeDialog()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Release Of Information Form - {{ currentItem.cn }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark text @click="closeDialog()">Close</v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <release-of-information-review :address="currentItem.address" :admin="true" :cn="currentItem.cn"
                    :username="currentItem.username" :contacts="currentItem.contacts" @closeDialog="closeDialog">
                </release-of-information-review>
            </v-dialog>
        </v-card-text>
    </v-card>
</template>

<script>
import ReleaseOfInformationReview from '../../../Student/ReleaseOfInformation/Review';

export default {
    name: 'release-of-information-data',
    components: {
        ReleaseOfInformationReview
    },
    props: {
        data: {
            required: true,
            type: Array
        }
    },
    data() {
        return {
            currentItem: '',
            dialog: false,
            filterTerm: '',
            headers: [{
                    text: 'Name',
                    align: 'start',
                    value: 'cn',
                },
                {
                    text: 'Address',
                    value: 'address',
                },
                {
                    text: 'Created',
                    value: 'dataCreated',
                },
                {
                    text: 'Last Updated',
                    value: 'lastUpdatedDate',
                },
                {
                    sortable: false,
                    text: 'Actions',
                    value: 'actions'
                }
            ],
        }
    },
    methods: {
        closeDialog() {
            this.dialog = false;
        },
        getLastUpdatedDate(item) {
            if (item.dataLastUpdated) {
                return `${item.dataLastUpdated}`;
            }

            return `${item.dataCreated}`;
        },
        openDialog(item) {
            this.currentItem = item;
            this.dialog = true;
        }
    },
    computed: {
        primaryColor() {
            return '#5867dd';
        },
        toolbarColor() {
            return '#1BC5BD'
        }
    }
}
</script>